var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2498 0.300295L9 7.55005L1.75025 0.300295C1.55797 0.10802 1.29719 5.61754e-07 1.02527 5.61754e-07C0.753351 5.61754e-07 0.49257 0.10802 0.300295 0.300295C0.108019 0.49257 0 0.753352 0 1.02527C0 1.29719 0.108019 1.55797 0.300295 1.75025L7.55005 9L0.300295 16.2498C0.108019 16.442 0 16.7028 0 16.9747C0 17.2466 0.108019 17.5074 0.300295 17.6997C0.49257 17.892 0.753351 18 1.02527 18C1.29719 18 1.55797 17.892 1.75025 17.6997L9 10.45L16.2498 17.6997C16.442 17.892 16.7028 18 16.9747 18C17.2466 18 17.5074 17.892 17.6997 17.6997C17.892 17.5074 18 17.2466 18 16.9747C18 16.7028 17.892 16.442 17.6997 16.2498L10.45 9L17.6997 1.75025C17.892 1.55797 18 1.29719 18 1.02527C18 0.753351 17.892 0.49257 17.6997 0.300295C17.5074 0.10802 17.2466 0 16.9747 0C16.7028 0 16.442 0.10802 16.2498 0.300295Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossIcon);
export default __webpack_public_path__ + "static/media/closeCrossIcon.3ac4b4a2691238d6c57926877b61e5dc.svg";
export { ForwardRef as ReactComponent };